"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundDownToMultiple = exports.roundUpToMultiple = exports.mod = void 0;
/**
 * Computes `a mod n` for integer inputs `a` and `n`
 *
 * Correctly handles negative values for `a`
 *
 * For context, see: https://web.archive.org/web/20090717035140if_/javascript.about.com/od/problemsolving/a/modulobug.htm
 */
var mod = function (a, n) { return ((a % n) + n) % n; };
exports.mod = mod;
function roundUpToMultiple(n, m) {
    return Math.ceil(n / m) * m;
}
exports.roundUpToMultiple = roundUpToMultiple;
function roundDownToMultiple(n, m) {
    return Math.floor(n / m) * m;
}
exports.roundDownToMultiple = roundDownToMultiple;
//# sourceMappingURL=index.js.map